import { render } from "./ProductReviewsTitle.vue?vue&type=template&id=266b55e5&scoped=true"
import script from "./ProductReviewsTitle.vue?vue&type=script&lang=js"
export * from "./ProductReviewsTitle.vue?vue&type=script&lang=js"

import "./ProductReviewsTitle.vue?vue&type=style&index=0&id=266b55e5&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-266b55e5"]])

export default __exports__